import React, { useEffect } from 'react';
import { Container, Grid } from '@mui/material';
import { useGlobal } from '../contexts/GlobalContext';
import { useBuild } from '../contexts/BuildContext';
import ScoringQueryColumn from '../scoring/ScoringQueryColumn';
import EnrichedResultsColumn from '../components/EnrichedResultsColumn';
import ScoringInfoColumn from '../scoring/ScoringInfoColumn';

const ScoringService = () => {
  const { setCurrentContext } = useGlobal();
  const { hits } = useBuild();

  useEffect(() => {
    setCurrentContext({
      product: 'build',
      page: 'scoring',
      ...(hits?.length && { numCandidates: hits.length }),
    });
    return () => setCurrentContext(null);
  }, [hits?.length, setCurrentContext]);

  return (
    <Container maxWidth="xl" sx={{ mt: 2 }}>
      <Grid container spacing={2} sx={{ height: 'calc(100vh - 120px)' }}>
        {/* Query Column */}
        <Grid size={{ xs: 12, md: 4 }}>
          <ScoringQueryColumn />
        </Grid>

        {/* Results Column */}
        <Grid size={{ xs: 12, md: 6 }}>
          <EnrichedResultsColumn />
        </Grid>

        {/* Info Column */}
        <Grid size={{ xs: 12, md: 2 }}>
          <ScoringInfoColumn />
        </Grid>
      </Grid>
    </Container>
  );
};

export default ScoringService;

